import {
  ApiCartChangeCartDeliveryAddressRequestedAction,
  apiCartChangeCartDeliveryAddressFailed,
  apiCartChangeCartDeliveryAddressSucceeded
} from '../../../api/cart/changeCartDeliveryAddressApi';
import { call, put } from 'typed-redux-saga';
import changeCartDeliveryAddressAction, {
  ChangeCartDeliveryAddressActionInput,
  ChangeCartDeliveryAddressActionResult
} from '@spa/lib/actions/cart/changeCartDeliveryAddressAction';

function* changeCartDeliveryAddressSaga({
  payload: { actionId: requestedActionId, customOrderType, deliveryAddress, parentActionId }
}: ApiCartChangeCartDeliveryAddressRequestedAction): Generator {
  try {
    const input: ChangeCartDeliveryAddressActionInput = { customOrderType, deliveryAddress };
    const { cartId, result }: ChangeCartDeliveryAddressActionResult = yield* call(
      changeCartDeliveryAddressAction,
      'changeCartDeliveryAddressAction',
      input
    );
    yield* put(
      apiCartChangeCartDeliveryAddressSucceeded({
        cartId,
        parentActionId,
        requestedActionId,
        result
      })
    );
  } catch {
    yield* put(
      apiCartChangeCartDeliveryAddressFailed({
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default changeCartDeliveryAddressSaga;
